import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import DescriptionGenerator from '../DescriptionGenerator/DescriptionGenerator';
import { BrandTilesUploadPage } from '../BrandTiles/BrandTilesUploadPage';
import ProtectedRoute from '../Auth/ProtectedRoute';
import InternalSyndigoUpdate from '../InternalSyndigoUpdate/InternalSyndigoUpdate';
import './Demo.css'
import Demo from './Demo';
import DemoGenerator from './DemoGenerator';
import { DemoImage } from './DemoImage';
import SocialMediaPostGenerator from '../SocialMediaPostGenerator/SocialMediaPostGenerator';

const traditionalApproachImage = require('../../assets/Traditional_Approach.png'); 
const thinkhausApproachImage = require('../../assets/Thinkhaus_AI_Approach.png'); 

const DemoWrapper = () => {

    return (
        <>
            <Routes>
                <Route element={<ProtectedRoute />} >
                    <Route path="/social" element={<SocialMediaPostGenerator/>} />
                    <Route path="/" element={<Demo />} />
                    <Route
                        path="traditional-approach"
                        element={
                            <DemoImage
                                src={traditionalApproachImage}
                                alt='Traditional Method For Content Generation'
                                dataTestId="page-1-id"
                                pageLinks={{ forward: '/demo/thinkhaus-approach', backward: '/demo' }}
                            />
                        }
                    />
                    <Route
                        path='thinkhaus-approach'
                        element={
                            <DemoImage
                                src={thinkhausApproachImage}
                                alt='Thinkhaus Method For Content Generation'
                                dataTestId="page-2-id"
                                pageLinks={{ forward: '/demo/generator', backward: '/demo/traditional-approach' }}
                            />
                    }
                    />
                    <Route
                        path='generator'
                        element={<DemoGenerator />}
                    />
                </Route>
            </Routes>
        </>
    );
};

export default DemoWrapper;
